import { render, staticRenderFns } from "./TeleconsultoIntroModal.vue?vue&type=template&id=782769c9&scoped=true&"
import script from "./TeleconsultoIntroModal.vue?vue&type=script&lang=js&"
export * from "./TeleconsultoIntroModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782769c9",
  null
  
)

export default component.exports